import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import DatePicker from 'vue2-datepicker';
import VueTimepicker from 'vue2-timepicker'
import VueGoodTablePlugin from 'vue-good-table';
import {createProvider} from "@/apollo";

import 'vue2-datepicker/index.css';
import 'vue2-timepicker/dist/VueTimepicker.css'
import "../src/design/app.scss";


import store from '@/state/store'
import permissionsCheck from "@/mixin/permissionsCheck";
import isUserStaff from "@/mixin/isUserStaff";

import App from './App.vue'
import i18n from './i18n'

import tinymce from 'vue-tinymce-editor'

import "../src/filters/NumeralsNumberFilter"

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(DatePicker);
// Vue.use(VueTimepicker);
Vue.use(VueGoodTablePlugin);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-timepicker', VueTimepicker)

Vue.mixin(permissionsCheck)
Vue.mixin(isUserStaff)

new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: h => h(App),

}).$mount('#app')
